import React, { useState, useEffect } from "react";
import Preloader from "./components/Pre";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Service from './components/Service/Service';
import CustomSoftware from './components/Service/CustomSoftware';
import MobileApplication from './components/Service/MobileApplication';
import DevopsCloudSolutions from './components/Service/DevopsCloudSolutions';
import QaTestingServices from './components/Service/QaTestingServices';
import OffShoreTeamServices from './components/Service/OffShoreTeamServices';

import BlogList from "./components/Blog/BlogList";
import BlogDetails from "./components/Blog/BlogDetails";

import '@flaticon/flaticon-uicons/css/all/all.css';

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <main className="main-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/service" element={<Service />} />
            <Route path="/custom_software" element={<CustomSoftware />} />
            <Route path="/mobile_application" element={<MobileApplication />} />
            <Route path="/devops_cloud" element={<DevopsCloudSolutions />} />
            <Route path="/qa_testing" element={<QaTestingServices />} />
            <Route path="/offshore_team" element={<OffShoreTeamServices />} />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blogs/:slug" element={<BlogDetails />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
